import React, { Component } from 'react';
import { connect } from 'react-redux';

import { petriCombos } from "../config/petri-combinations";

class PetriDish extends Component {

    render() {
        const { currentBackgroundImage } = this.props;

        return (
            <div className="petri-dish-container">
                { petriCombos.map( ( combo, key ) => {
                    if( combo.image === currentBackgroundImage ) {
                        return( <img src={ combo.image } key={ "petri" + key } className="active" /> );
                    } else {
                        return( <img src={ combo.image } key={ "petri" + key } /> );
                    }
                })};
            </div>
        );
    }

}

const mapStateToProps = ( state ) => {
    return {
        currentBackgroundImage: state.activePetri.image
    };
};

export default connect(mapStateToProps)(PetriDish);


// WEBPACK FOOTER //
// ./src/components/petri-dish.js